"use strict";import{tag as o}from"../custom-tag.js";export function videoSeriesReIcon({height:e=16,width:r=16,hidden:t=!1,title:i="Video series re"}={}){return o`
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width=${r}
      height=${e}
      fill="transparent"
      viewBox="0 0 24 24"
      aria-hidden="${t?"true":"false"}"
      role="img"
      aria-label="${i}"
    >
      <path
        stroke="currentColor"
        stroke-linejoin="round"
        stroke-width=".369"
        d="M6.92 5.71V3l15.58 8.807-15.58 8.806v-2.71m0-12.193L1.5 3v17.613l5.42-2.71m0-12.193v12.193"
      />
    </svg>
  `}
//# sourceMappingURL=videoSeriesRe.js.map
